import { render, staticRenderFns } from "./ListNewStaff.vue?vue&type=template&id=fe45d60c"
import script from "./ListNewStaff.vue?vue&type=script&lang=js"
export * from "./ListNewStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports